import * as React from 'react';
import EditGray from './edit-gray.svg';

type Props = {
    className?: string;
    styleName?: string;
};

export const Edit = ({ className }: Props) => <img className={className} src={EditGray} />;
